module.exports = __webpack_public_path__ + "static/media/driver_instruction.8f2be974.svg";